import React from 'react';

import { IComponentPassword } from '../../component.d';
import { RenderRequired } from './Form';

const AllForFormPassword = function(props: IComponentPassword) {
  const {
    cid,
    field,
    align,
    width,
    onChange,
    required,
    placeholder,
    label,
    type
  } = props;
  return (
    <div className="all-for-password">
      <div className="weui-cells__group weui-cells__group_form">
        <div
          className="weui-cells weui-cells_form"
          style={{ width: `${width}%` }}
        >
          <div className="weui-cell weui-cell_active">
            {label ? (
              <div className="weui-cell__hd">
                <label className="weui-label">
                  {field} {RenderRequired(required)}
                </label>
              </div>
            ) : null}
            <div className="weui-cell__bd">
              <input
                type="password"
                name={cid}
                className="weui-input"
                placeholder={placeholder}
                onChange={e => {
                  onChange(type, field, e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllForFormPassword;
